import { memo } from 'react';
import cn from 'classnames';
import { SkuExtended } from 'types/sku.types';
import { prevented } from '@utils/event';
import styles from './serviceprice.module.scss';
import { formatPriceTypeHourly } from '@utils/currency';

type ServicePriceOriginalProps = {
  sku: SkuExtended;
  sm?: boolean;
  showFixedPrice?: boolean;
  linethroughPrice?: boolean;
  brandLogo?: string;
  onInfoClick: BaseAnyFunction;
};

const ServicePriceOriginal = ({ sku, sm, showFixedPrice = false, linethroughPrice = false, onInfoClick }: ServicePriceOriginalProps) => {
  const baseStyles = cn({ p0: !sm, p1: sm, nowrap: true });

  if (sku.showFree) {
    return (
      <span className={baseStyles}>
        <span className="text-weight-medium">Free</span>
      </span>
    );
  }

  return (
    <>
      {linethroughPrice ? (
        <div className={cn(styles.linethroughPrice)}>
          <h5 className="text-weight-medium alertRed500 paddingRight-tiny1">{sku.prices.price}</h5>
          <p className="p2 line-through n700">{sku.listPrice?.formatted}</p>
        </div>
      ) : (
        <span className={baseStyles}>
          {!showFixedPrice && 'Starting at'} <span className="text-weight-medium">{formatPriceTypeHourly({ sku, price: sku.prices.price })}</span>
        </span>
      )}

      {sku.prices.memberPrice && (
        <>
          &nbsp;|&nbsp;
          <a href="#" className={cn('lightBlue', baseStyles)} onClick={prevented(onInfoClick)}>
            Member Price <span className="text-weight-medium">{sku.prices.memberPrice}</span>
          </a>
        </>
      )}
    </>
  );
};

export default memo(ServicePriceOriginal);
